// eslint-disable-next-line import-x/no-named-as-default -- i18next default export
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enCommon from './locales/en/common.json'
import koCommon from './locales/ko/common.json'
import viCommon from './locales/vi/common.json'

const resources = {
  ko: { common: koCommon },
  en: { common: enCommon },
  vi: { common: viCommon },
}

const supportedLanguages = ['ko', 'en', 'vi']

const resolveInitialLanguage = (): string => {
  try {
    const stored = localStorage.getItem('i18nextLng')
    if (stored && supportedLanguages.includes(stored)) {
      return stored
    }
  } catch {
    // localStorage unavailable — fall through to default
  }
  return 'ko'
}

// eslint-disable-next-line @typescript-eslint/no-floating-promises, import-x/no-named-as-default-member -- i18next init pattern
i18n.use(initReactI18next).init({
  lng: resolveInitialLanguage(),
  resources,
  fallbackLng: 'ko',
  supportedLngs: supportedLanguages,
  ns: ['common'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
})

export { i18n }
